import axiosInstance from '../../services/ApiInstance'

export const handleGetProjectReport = async (request: {
  projectIds: string[]
  startDate: string
  endDate: string
  projectReportType: string
  leaderId: string
  includeCosts: boolean
}) => {
  const { projectIds, startDate, endDate, projectReportType, leaderId, includeCosts } = request
  return await axiosInstance.post(
    `reports/projects?projectReportType=${projectReportType}&includeCosts=${includeCosts}`,
    { uuidList: projectIds, startDate: startDate, endDate: endDate, leaderId },
    { responseType: 'blob' }
  )
}

export const handleGetEmployeeReport = async (request: { employeeId: string; startDate: string; endDate: string }) => {
  const { employeeId, startDate, endDate } = request
  return await axiosInstance.post(
    `reports/employees/${employeeId}`,
    { startDate: startDate, endDate: endDate },
    { responseType: 'blob' }
  )
}

export const handleGetEmployeesReport = async (request: {
  employeeIds: string[]
  startDate: string
  endDate: string
  leaderId: string
}) => {
  const { employeeIds, startDate, endDate, leaderId } = request
  return await axiosInstance.post(
    `reports/employees`,
    { uuidList: employeeIds, startDate: startDate, endDate: endDate, leaderId },
    { responseType: 'blob' }
  )
}

export const handleGetWorklogExcel = async (employeeID: string, year: number) => {
  return await axiosInstance.get(`export/user/${employeeID}/${year}`, { responseType: 'blob' })
}

export const handleGetContractExcel = async (request: {
  startDate: string
  endDate: string
  employmentTypes: string[]
}) => {
  const { startDate, endDate, employmentTypes } = request
  return await axiosInstance.post(
    `reports/employees/contract`,
    { startDate, endDate, employmentTypes },
    { responseType: 'blob' }
  )
}

export const handleGetWorklogZip = async (year: number) => {
  return await axiosInstance.get(`export/${year}/all`, { responseType: 'blob' })
}

export const handleGetTechnologyReport = async (request: {
  employeeIds: string[]
  technologyDefinitionIds: (string | number)[]
  minimumLevel: number
  maximumLevel: number
  alternativeAppearance: boolean
}) => {
  const { employeeIds, technologyDefinitionIds, minimumLevel, maximumLevel, alternativeAppearance } = request
  return await axiosInstance.post(
    `reports/technology`,
    { employeeIds, technologyDefinitionIds, minimumLevel, maximumLevel, alternativeAppearance },
    { responseType: 'blob' }
  )
}
